import cityInfo from '../../static/js/city-data'
import moment from 'moment'
export default  {
  //时间格式化
  moment,
  //去除字符串前后空格
  Trim:function(str){ return str.replace(/(^\s*)|(\s*$)/g, ""); },
  //获取省市区
  newGetRegion(arr){
    let str = ''
    cityInfo.forEach((list)=>{
      if(list.value === arr[0]){
        str = `${list.label}`;
        list.children.forEach((item)=>{
          if(item.value === arr[1]){
            str = `${str}/${item.label}`
            item.children.forEach((end)=>{
              if(end.value === arr[2]){
                str = `${str}/${end.label}`
              }
            })
          }
        })
      }
    })
    return str;
  },
  //获取url参数
  UrlSearch:function () {
    var name,value;
    var str=location.href; //取得整个地址栏
    var num=str.indexOf("?");
    str=str.substr(num+1); //取得所有参数
    var arr=str.split("&"); //各个参数放到数组里
    for(var i=0;i < arr.length;i++){
      num=arr[i].indexOf("=");
      if(num>0){
        name=arr[i].substring(0,num);
        value=arr[i].substr(num+1);
        this[name]=value;
      }
    }
  },
  //下载文件
  download:function (url,obj) {
    let keyArr = [];
    if(obj){
      keyArr = Object.keys(obj);
    }
    let form =  document.createElement('form');
    form.id = 'formId';
    form.style.display = "none";
    form.setAttribute("method","post");
    form.setAttribute("action",url);
    document.getElementsByTagName("body")[0].appendChild(form);
    for(let k of keyArr){
      var input=document.createElement("input");
      input.setAttribute("name",k);
      input.setAttribute("value",obj[k]);
      document.getElementById("formId").appendChild(input);
    }
    form.submit();
    document.getElementsByTagName("body")[0].removeChild(form);
  },
  getRegion(value,vm){
    if(value[0]){
      for(let y in cityInfo){
        if(cityInfo[y].value === value[0]){
          /*vm.codeIndexArr = [parseInt(y)+1];*/
          vm.region = cityInfo[y].label;
          break;
        }
      }
    }else{
      vm.region = '';
    }
    if(value[1] || value[1] === 0){
      for(let y in cityInfo){
        if(cityInfo[y].value === value[0]){
          for(let z in cityInfo[y].children){
            if(cityInfo[y].children[z].value == value[1]){
              /*vm.codeIndexArr = [parseInt(y)+1,parseInt(z)+1];*/
              vm.region += "/"+cityInfo[y].children[z].label;
              break;
            }
          }
        }
      }
    }
    if(value[2]) {
      for (let y in cityInfo) {
        if(cityInfo[y].value === value[0]) {
          for (let z in cityInfo[y].children) {
            if(cityInfo[y].children[z].value == value[1]) {
              for (let i in cityInfo[y].children[z].children) {
                if (cityInfo[y].children[z].children[i].value == value[2]) {
                  /*vm.codeIndexArr = [parseInt(y) + 1, parseInt(z) + 1, parseInt(i) + 1];*/
                  vm.region += "/" + cityInfo[y].children[z].children[i].label
                  break;
                }
              }
            }
          }
        }
      }
    }
  },
  //通过身份证号码获取年龄
  getAgeByIDNo:function(IDNo) {
    if (!IDNo) {
      return '';
    }

    if(IDNo.length == 18){
      let birthdayYear = parseInt(IDNo.substr(6,4))
      let nowYear = (new Date()).getFullYear()
      return nowYear - birthdayYear
    }else if(IDNo.length == 15){
      let birthdayYear = parseInt(19+IDNo.substr(6,2))
      let nowYear = (new Date()).getFullYear()
      return nowYear - birthdayYear
    }
  },
  // cast RegionLabel to RegionValue
  getRegionValue(label, cityInfo1){
    let labelArr = label.split("/");
    for (let y in cityInfo1) {
      if (labelArr[0] !== undefined && labelArr[0] === cityInfo1[y].label) {
        for (let z in cityInfo1[y].children) {
          if (labelArr[1] !== undefined && labelArr[1] === cityInfo1[y].children[z].label) {
            for (let i in cityInfo1[y].children[z].children) {
              if (labelArr[2] !== undefined && cityInfo1[y].children[z].children[i].label === labelArr[2]) {
                return [(cityInfo1[y].value), (cityInfo1[y].children[z].value), (cityInfo1[y].children[z].children[i].value)];
              }
            }

            return [(cityInfo1[y].value), (cityInfo1[y].children[z].value)];
          }
        }

        return [cityInfo1[y].value];
      }
    }
  },

  getLableByVal(valueArr, cityInfo1){
    for (let y in cityInfo1) {
      if (valueArr[0] !== undefined && valueArr[0] === cityInfo1[y].value) {
        for (let z in cityInfo1[y].children) {
          if (valueArr[1] !== undefined && valueArr[1] === cityInfo1[y].children[z].value) {
            for (let i in cityInfo1[y].children[z].children) {
              if (valueArr[2] !== undefined && cityInfo1[y].children[z].children[i].value === valueArr[2]) {
                return [(cityInfo1[y].label), (cityInfo1[y].children[z].label), (cityInfo1[y].children[z].children[i].label)];
              }
            }

            return [(cityInfo1[y].label), (cityInfo1[y].children[z].label)];
          }
        }

        return [(cityInfo1[y].label)];
      }
    }
  },

  // get uuid
  guid: ()=> {
    function S4() {
      return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    }
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
  },
  // 消息提示
  msgTips: (vm, msg, type) => {
    vm.$message({
      message: msg,
      type: type
    });
  },

  // 获取文件的根路径
  getRootPath: () => {
    let pathName = window.location.pathname.substring(1);
    let webName = pathName === '' ? '' : pathName.substring(0, pathName.indexOf('/'));
    if (webName === "") {
      return window.location.protocol + '//' + window.location.host;
    } else {
      return window.location.protocol + '//' + window.location.host + '/' + webName;
    }
  },

  //利用Array.from将Set结构转换成数组,es6数组去重
  dedupe:function(array){
    return Array.from(new Set(array));
  },

  //合并两个数组，去重
  concat_:function(arr1,arr2){
    //不要直接使用var arr = arr1，这样arr只是arr1的一个引用，两者的修改会互相影响
    var arr = arr1.concat();
    //或者使用slice()复制，var arr = arr1.slice(0)
    for(var i=0;i<arr2.length;i++){
      arr.indexOf(arr2[i]) === -1 ? arr.push(arr2[i]) : 0;
    }
    return arr;
  },
  //数组，去重
  concat_2:function(arr){
    var result = [], i, j, len = arr.length;
    for(i = 0; i < len; i++){
      for(j = i + 1; j < len; j++){
        if(arr[i] === arr[j]){
          j = ++i;
        }
      }
      result.push(arr[i]);
    }
    return result;
  },

  // 设置cookie
  setCookie: function(c_name,value,expiremMinutes){
    var exdate = new Date();
    exdate.setTime(exdate.getTime() + expiremMinutes * 60 * 1000);
    document.cookie= c_name + "=" + escape(value)+((expiremMinutes==null) ? "" : ";expires="+exdate.toGMTString());
  },

  // 读取cookie
  getCookie: function(c_name){
    if (document.cookie.length>0)
    {
      var c_start=document.cookie.indexOf(c_name + "=");
      if (c_start!=-1)
      {
        c_start=c_start + c_name.length+1;
        var c_end=document.cookie.indexOf(";",c_start);
        if (c_end==-1)
          c_end = document.cookie.length
        return unescape(document.cookie.substring(c_start, c_end))
      }
    }
    return ""
  },

  // 删除cookie
  delCookie: function(c_name){
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.getCookie(c_name);
    if(cval!=null){
      document.cookie = c_name + "=" + cval + ";expires=" + exp.toGMTString();
    }
  },

  //标准时间格式化。如：Wed Jun 13 2018 15:22:44 GMT+0800 (中国标准时间)=>"2018-6-13 15:22:44"
  standardDateTodate:function (inputTime) {
    var date = new Date(inputTime);
    var newDate=date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
    return newDate;
  },
  //unix时间戳转换为 2018-6-13 15:22:44
  formatDateTime:function(inputTime) {
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
  },
  // 深度拷贝
  deepClone: function (obj) {
    let objClone = Array.isArray(obj)?[]:{};
    if(obj && typeof obj==="object"){
      for(let key in obj){
        if(obj.hasOwnProperty(key)){
          //判断ojb子元素是否为对象，如果是，递归复制
          if(obj[key]&&typeof obj[key] ==="object"){
            objClone[key] = this.deepClone(obj[key]);
          }else{
            //如果不是，简单复制
            objClone[key] = obj[key];
          }
        }
      }
    }
    return objClone;
  },

};



// WEBPACK FOOTER //
// ./src/util/api.js